import {
	request,
} from '@/api/_service.js'

/**
 * @description 登录
 * @param {Object} data 登录携带的信息
 */
export function SYS_USER_LOGIN({
	username,
	password,
	state,
}) {
	console.log('-----', process.env.VUE_APP_TOKEN_URI)
	// 接口请求
	return request({
		url: process.env.VUE_APP_TOKEN_URI,
		method: 'post',
		params: {
			client_id: process.env.VUE_APP_CLIENT_ID,
			client_secret: process.env.VUE_APP_CLIENT_SECRET,
			grant_type: 'password',
			username,
			password,
			state,
		},
		auth: {
			username: process.env.VUE_APP_CLIENT_ID,
			password: process.env.VUE_APP_CLIENT_SECRET
		},
	})
}

/**
 * @description 登录
 * @param {Object} data 登录携带的信息
 */
export function SYS_LOGIN_FOR_CLIENT({
	client_id,
	client_secret,
	scope,
}) {
	// 接口请求
	return request({
		url: process.env.VUE_APP_TOKEN_URI,
		method: 'post',
		params: {
			client_id,
			client_secret,
			grant_type: 'client_credentials',
			scope,
		},
		auth: {
			username: client_id,
			password: client_secret
		},
	})
}

export function SYS_USER_LOGIN_BY_CODE({
	code,
	state,
}) {
	// 接口请求
	return request({
		url: process.env.VUE_APP_TOKEN_URI,
		method: 'post',
		params: {
			code,
			client_id: process.env.VUE_APP_CLIENT_ID,
			client_secret: process.env.VUE_APP_CLIENT_SECRET,
			grant_type: 'authorization_code',
			redirect_uri: `${process.env.VUE_APP_SERVER}/login`,
			state,
		},
		auth: {
			username: process.env.VUE_APP_CLIENT_ID,
			password: process.env.VUE_APP_CLIENT_SECRET
		},
	})
}

export function SYS_USER_LOGOUT() {
	return request({
		url: `${process.env.VUE_APP_LOGIN_API}/logout`,
		method: 'delete'
	})
}

export function SYS_USER_INFO() {
	return request({
		url: `/me`
	})
}
